import { render, staticRenderFns } from "./suitch-prop-widget.vue?vue&type=template&id=8c541e4e&"
import script from "./suitch-prop-widget.vue?vue&type=script&lang=js&"
export * from "./suitch-prop-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports